<div class="card" role="button" [ngClass]="{ 'card-button': button }" (click)="open()">
    <div class="card-img-top">
        <img width="281" height="255" [src]="imagePdv || image" *ngIf="!skeleton">
        <ngx-skeleton-loader [theme]="{ 'height': '100%' }" *ngIf="skeleton"></ngx-skeleton-loader>
    </div>
    <div class="card-body d-flex align-items-center">
        <div class="event-date" *ngIf="customEvents.indexOf(id) <= -1">
            <ng-container *ngIf="!skeleton">
                <div class="bg">
                    <span class="day">{{ date | date:'dd'}}</span>
                    <span class="month text-uppercase">{{ (date | date:'MMM')?.slice(0, 3) }}</span>
                </div>
            </ng-container>
            <ngx-skeleton-loader [theme]="{ 'height': '100%' }" *ngIf="skeleton"></ngx-skeleton-loader>
        </div>
        <div class="event-date" style="height: 89px; min-width: 90px; line-height: 20px;" *ngIf="customEvents.indexOf(id) > -1">
            <ng-container *ngIf="!skeleton">
                <div class="bg text-center pt-2 pb-2">
                    <span *ngIf="id == '12e8e480-c1f3-4e42-b4fc-006c4913ca89'" class="" style="font-size: 20px; width: 100px;"><b>07 - 23</b></span>
                    <span *ngIf="id == '12e8e480-c1f3-4e42-b4fc-006c4913ca89'" class="month text-uppercase">FEV </span>
                    <span *ngIf="id == 'e31c2e19-5c6c-46b5-be0b-26ab22ec7d1a'" class="" style="font-size: 20px; width: 60px;"><b>27/02 <br />a  <br />04/03</b></span>
                    <span *ngIf="id == '034f7ecc-db4f-4043-8ce4-a911ad9c0ac7'" class="" style="font-size: 20px; width: 60px;"><b>27/02 <br />a  <br />04/03</b></span>
                </div>
            </ng-container>
            <ngx-skeleton-loader [theme]="{ 'height': '100%' }" *ngIf="skeleton"></ngx-skeleton-loader>
        </div>
        <div class="pe-2 ps-sm-3 pe-sm-0 w-100">
            <ng-container *ngIf="!skeleton">
                <h5 class="card-title mb-1">{{ name }}</h5>
                <p class="card-text mb-1">{{ address }}</p>
                <p class="card-text mb-1" *ngIf="id != 'ec026c2c-4ddb-4549-8ac3-547cb544ff4e'"> {{ city }} - {{ uf }}</p>
                <p class="card-text mb-1" *ngIf="id == 'ec026c2c-4ddb-4549-8ac3-547cb544ff4e'"> Barletta - Apúlia</p>
                <p *ngIf="showTime == true" class="text-grad mb-0">{{ date | date:'HH:mm':'GMT' }} hrs</p>
            </ng-container>
            <ng-container *ngIf="skeleton">
                <ngx-skeleton-loader [theme]="{ 'margin': 0 }"></ngx-skeleton-loader>
                <ngx-skeleton-loader [theme]="{ 'margin': 0, 'width': '80%' }"></ngx-skeleton-loader>
                <ngx-skeleton-loader [theme]="{ 'margin': 0, 'width': '60%' }"></ngx-skeleton-loader>
            </ng-container>
        </div>
    </div>
</div>
